export default __webpack_public_path__ + "static/asphalt-chronicles-logo-6c8fa3e4a7b9e624ec26c5fdc43af50e.svg";